import { Goal } from '@/types/financial';
import { logger } from '@/utils/logger';

export interface GoalsState {
  goals: Goal[];
  isLoading: boolean;
}

export type GoalsAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_GOALS'; payload: Goal[] }
  | { type: 'ADD_GOAL'; payload: Goal }
  | { type: 'UPDATE_GOAL'; payload: { id: string; updates: Partial<Goal> } }
  | { type: 'DELETE_GOAL'; payload: string }
  | { type: 'CLEAR_GOALS' };

export const initialState: GoalsState = {
  goals: [],
  isLoading: false,
};

export function goalsReducer(
  state: GoalsState,
  action: GoalsAction
): GoalsState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_GOALS':
      return { 
        ...state, 
        goals: action.payload,
        isLoading: false
      };

    case 'ADD_GOAL':
      logger.debug('Adding goal to state', { id: action.payload.id });
      return {
        ...state,
        goals: [...state.goals, action.payload],
      };

    case 'UPDATE_GOAL': {
      const updated = state.goals.map(g =>
        g.id === action.payload.id ? { ...g, ...action.payload.updates } : g
      );
      logger.debug('Updated goal in state', { id: action.payload.id });
      return { ...state, goals: updated };
    }

    case 'DELETE_GOAL': {
      const filtered = state.goals.filter(g => g.id !== action.payload);
      logger.debug('Deleted goal from state', { id: action.payload });
      return { ...state, goals: filtered };
    }

    case 'CLEAR_GOALS':
      return { ...state, goals: [] };

    default:
      return state;
  }
}
